import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { ThumbDown, ThumbUp } from '@material-ui/icons';
import { clearCookie } from '../../functions/Auth';
import Cookies from 'js-cookie';

import AllFiles from './AllFiles';
import PendingFiles from './PendingFiles';
import ApprovedFiles from './ApprovedFiles';
import RejectedFiles from './RejectedFiles';
import ErrorFiles from './ErrorFiles';
import '../../scss/components/_data_management.scss';
import API_PATH from "../../constants/config.json";
import FileDownloading from '../Errors/FileDownloading';
import MapContext from '../../context/MapContext';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

let stationData;
let stationIDData = [];

const DataManagement = props => {

    let history = useHistory();
    const theme = useTheme();
    const [value, setValue] = useState(0);

    const [needToReload, setNeedToReload] = useState(false);

    const [selectedFileID, setSelectedFileID] = useState(null);
    const [selectedFileStatus, setSelectedFileStatus] = useState(null);
    const [showActions, setShowActions] = useState(false);
    const [actionsTop, setActionsTop] = useState(0);
    const [actionsLeft, setActionsLeft] = useState(0);
    const [loader, setloader] = React.useState({ filename: "", loader: false });
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [errorDialogue, setErrorDialogue] = React.useState(false);
    const [stationDetails, setStationDetails] = useState([]);
    const [scrolled, setScrolled] = useState(false);

    const { updateStationDetails } = useContext(MapContext);

    useEffect(() => {
        getAswToken();
        getStationsData();
        if(!needToReload) {
            setNeedToReload(true);
        }
    }, [])
    

    const getStationsData = async () => {
        try {
          let headers = Cookies.get('payload')
            ? {
              'agencyid': sessionStorage.getItem('agency_id'),
              'payload': Cookies.get('payload'),
            }
            : {
              'agencyid': sessionStorage.getItem('agency_id'),
            }
          //this code is create Geojson marker
          return axios({
            method: 'get',
           url: API_URL + API_PATH.stationListGeov2,
          
            headers: headers,
          }).then(function (response) {
            if (response && response.status && response.status == '200') {
              let myGeoJsonLayerData = response.data.data;
              if(myGeoJsonLayerData.features) {
                  setStationDetails(myGeoJsonLayerData.features);
              }
            }
          })
        } catch (error) {
          console.error(error);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setNeedToReload(true);
        setScrolled(false);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleShowActions = (e,file_id, status, rowData) => {
        if( (status === 'Approved' || status === 'Ready') && rowData.bucket_name !== 'N/A' && rowData.bucket_name && rowData.bucket_name !== '') {
            // sessionStorage.setItem('viewUserId', user_id);
            setSelectedFileID(file_id);
            setSelectedFileStatus(status);
            setActionsTop(e.pageY);
            setActionsLeft(e.pageX-107);
            setShowActions(true);
        }
    }

    const handleClickAway = () => {
        setShowActions(false);
    }

    const changeFileStatus = (status, ids=null) => {
        setShowActions(false);
        setNeedToReload(false);
        try {
            axios({
                method: 'post',
                data: {
                    file_id: ids ? ids : [selectedFileID],
                    statusId: status
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.changeFileStatusAPIv2,
            })
                .then(async function (response) {
                    setNeedToReload(true);
                    if(response.data.stations) {
                        axios({
                            method: 'post',
                            data: {
                                stations: response.data.stations
                            },
                            headers: {
                                'payload': Cookies.get('payload'),
                                'agencyid': sessionStorage.getItem('agency_id')
                            },
                            url: API_URL + API_PATH.updateExportData,
                        })
                        .then(async function (response2) {
                        })
                        let intersecionsArr = response.data.stations.intersection;
                        if (intersecionsArr.length > 0 ) {
                            axios({
                                method: 'post',
                                data: {
                                    stationIds: intersecionsArr
                                },
                                headers: {
                                    'payload': Cookies.get('payload'),
                                },
                                url: API_URL + API_PATH.createGlobalScenario,
                            }).then(async function (response2) {
                                if(sessionStorage.getItem("stationIdDetails")) {
                                    if(intersecionsArr.includes(parseInt(sessionStorage.getItem("stationIdDetails")))) {
                                        updateStationDetails({
                                            station_id: sessionStorage.getItem("stationIdDetails")
                                        });
                                    }
                                }
                            });
                        }
                    }
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }

    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                } else {
                    console.log("Do Not Get Any Station ID");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

    const downloadFile = (file_id, bucketName, filename, originalFileName) => {
        setloader({ filename: file_id, loader: true });
        let OIDToken = Cookies.get('idToken');
        AWS.config.update(
            {
                region: 'us-west-2',
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: idintityPool,
                    Logins: {
                        [aswLogins]: OIDToken
                    }
                })
            }
        );
        let s3 = new AWS.S3();
        s3.getSignedUrl('getObject',{ 
            Bucket: bucketName, 
            Key: filename, 
            Expires: 86400,
            ResponseContentDisposition :  `attachment; filename="${originalFileName}"`
        }, function (
            error,
            url
        ) {
            if (error != null) {
                handleOpenDialogueBox();
                loader.loader = false
                setloader(loader);
            } else {
                // let blob = new Blob([data.Body], { type: data.ContentType });
                // let link = document.createElement("a");
                // link.href = window.URL.createObjectURL(blob);
                // link.download = originalFileName;
                // link.click();
                let link = document.createElement("a");
                link.href = url;
                link.target='_blank';
                link.download = originalFileName;
                link.click();  
                loader.loader = false
                setloader(loader);
            }
        });
    };

    const handleOpenDialogueBox = () => {
        setErrorDialogue(true);
    }

    const handleCloseDialogueBox = () => {
        setErrorDialogue(false);
    }

    const handleGoToDetails = (row) => {
        let selId = row.client_station_id;
        stationDetails.forEach(function(st, ind) {
            let det = st.properties;
            if(det.client_station_id === selId) {
                let st_type = det.station_type;
                if(st_type === 2)
                    window.open('/intersection_details?station='+selId, '_blank');
                else 
                    window.open('/midblock_details?station='+selId, '_blank');
            }
        })
    }

    const handleScroll = (tableRef) => {
        if (tableRef.current) {
          const { scrollTop } = tableRef.current.children[0].children[1].children[0].children[0].children[0].children[0].children[1];
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="data-management-main">
                <Container className="data-management-container" maxWidth="lg">
                    <AppBar position="static" color="default" className="tabs-header">
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="All" {...a11yProps(0)} id="all_tab" data-testid="allTab" />
                            <Tab label="Pending" {...a11yProps(1)} id="pending_tab" data-testid="pendingTab" />
                            <Tab label="Approved" {...a11yProps(2)} id="approved_tab" data-testid="approvedTab" />
                            <Tab label="Rejected" {...a11yProps(3)} id="rejected_tab" data-testid="rejectedTab" />
                            <Tab label="Error" {...a11yProps(4)} id="error_tab" data-testid="errorTab" />
                        </Tabs>
                        <div>
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setOpenDataManagement(false)} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} >
                        <div className="files-table-cnt" >
                            <AllFiles 
                                handleShowActions={handleShowActions}
                                needToReload={needToReload}
                                downloadFile={downloadFile}
                                loader={loader}
                                handleGoToDetails={handleGoToDetails}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={1} dir={theme.direction} >
                        <div className="files-table-cnt" >
                            <PendingFiles 
                                handleShowActions={handleShowActions}
                                needToReload={needToReload}
                                downloadFile={downloadFile}
                                loader={loader}
                                changeFileStatus={changeFileStatus}
                                handleGoToDetails={handleGoToDetails}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={2} dir={theme.direction} >
                        <div className="files-table-cnt" >
                            <ApprovedFiles 
                                handleShowActions={handleShowActions}
                                needToReload={needToReload}
                                downloadFile={downloadFile}
                                loader={loader}
                                changeFileStatus={changeFileStatus}
                                handleGoToDetails={handleGoToDetails}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={3} dir={theme.direction} >
                        <div className="custom-td-padding" >
                            <RejectedFiles 
                                handleShowActions={handleShowActions}
                                needToReload={needToReload}
                                downloadFile={downloadFile}
                                loader={loader}
                                handleGoToDetails={handleGoToDetails}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                        <TabPanel value={value} index={4} dir={theme.direction} >
                        <div className="custom-td-padding" >
                            <ErrorFiles 
                                handleShowActions={handleShowActions}
                                needToReload={needToReload}
                                downloadFile={downloadFile}
                                loader={loader}
                                handleGoToDetails={handleGoToDetails}
                                handleScroll={handleScroll}
                                scrolled={scrolled}
                            />
                        </div>
                        </TabPanel>
                    </SwipeableViews>
                </Container>
            </div>
            {
                showActions &&
                <ClickAwayListener onClickAway={handleClickAway}>
                <div className="actions-panel" style={{top: actionsTop+'px', left: actionsLeft+'px'}}>
                        {
                            selectedFileStatus !== 'Approved' &&
                            <div onClick={() => changeFileStatus(3)}>
                                <ThumbUp />
                                <label>Approve</label>
                            </div>
                        }
                        <div onClick={() => changeFileStatus(5)}>
                            <ThumbDown />
                            <label>Reject</label>
                        </div>
                    </div>
                </ClickAwayListener>
            }
            <FileDownloading 
                errorDialogue={errorDialogue}
                handleCloseDialogueBox={handleCloseDialogueBox}
            />
        </React.Fragment>
    )
}

export default DataManagement;